export default "__VITE_ASSET__D3DhZ6$z__"